import { withPopover } from '@vlabs/monokit/shared/ui/popovers/withPopover';
import { SideMenuFilterItem } from '@vlabs/monokit/shared/ui/side-menu-filter-item';

import { Popovers } from './popovers';

const withRightPopover = withPopover({ placement: 'right' });
const withLeftPopover = withPopover({ placement: 'left' });

const withSideMenuItemRightPopover = withRightPopover(SideMenuFilterItem);
const withSideMenuItemLeftPopover = withLeftPopover(SideMenuFilterItem);

// EVENT FILTERS WITH RIGHT POPOVER
// GENERAL
const DateFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.DateFilterPopover);
const VideoSourceFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.VideoSourceFilterPopover);
const HandlersFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.HandlersFilterPopover);
const SimilarityFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.SimilarityFilterPopover);
// COMPARING ATTRIBUTES
const ComparingAttributeFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.ComparingAttributeFilterPopover);
const TopSimilarObjectsFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.TopSimilarObjectsFilterPopover);
// FACE ATTRIBUTES
const GenderFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.GenderFilterPopover);
const AgeFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.AgeFilterPopover);
const EmotionFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.EmotionsFilterPopover);
const MasksFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.MasksFilterPopover);
const LivenessFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.LivenessFilterPopover);
const DeepfakeFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.DeepfakeFilterPopover);
const FaceIdsFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.FaceIdsFilterPopover);
// BODY ATTRIBUTES
const ApparentGenderFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.ApparentGenderFilterPopover);
const ApparentAgeFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.ApparentAgeFilterPopover);
const UpperAttributesFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.UpperAttributesFilterPopover);
const LowerAttributesFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.LowerAttributesFilterPopover);
const ShoesFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.ShoesFilterPopover);
const HeadWearFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.HeadWearFilterPopover);
const BackpackFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.BackpackFilterPopover);
// LOCATION
const LocationFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.LocationFilterPopover);

export const EventFiltersWithRightPopover = {
  General: {
    DateFilter: DateFilterWithRightPopover,
    VideoSourceFilter: VideoSourceFilterWithRightPopover,
    HandlersFilter: HandlersFilterWithRightPopover,
    SimilarityFilter: SimilarityFilterWithRightPopover,
  },
  Comparing: {
    ComparingAttributeFilter: ComparingAttributeFilterWithRightPopover,
    TopSimilarObjectsFilter: TopSimilarObjectsFilterWithRightPopover,
  },
  Face: {
    GenderFilter: GenderFilterWithRightPopover,
    AgeFilter: AgeFilterWithRightPopover,
    EmotionFilter: EmotionFilterWithRightPopover,
    MasksFilter: MasksFilterWithRightPopover,
    LivenessFilter: LivenessFilterWithRightPopover,
    DeepfakeFilter: DeepfakeFilterWithRightPopover,
    FaceIdsFilter: FaceIdsFilterWithRightPopover,
  },
  Body: {
    ApparentGenderFilter: ApparentGenderFilterWithRightPopover,
    ApparentAgeFilter: ApparentAgeFilterWithRightPopover,
    UpperAttributesFilter: UpperAttributesFilterWithRightPopover,
    LowerAttributesFilter: LowerAttributesFilterWithRightPopover,
    ShoesFilter: ShoesFilterWithRightPopover,
    HeadWearFilter: HeadWearFilterWithRightPopover,
    BackpackFilter: BackpackFilterWithRightPopover,
  },
  Location: {
    LocationFilter: LocationFilterWithRightPopover,
  },
};

// EVENT FILTERS WITH LEFT POPOVER
// GENERAL
const DateFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.DateFilterPopover);
const VideoSourceFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.VideoSourceFilterPopover);
const HandlersFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.HandlersFilterPopover);
const SimilarityFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.SimilarityFilterPopover);
// COMPARING ATTRIBUTES
const ComparingAttributeFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.ComparingAttributeFilterPopover);
const TopSimilarObjectsFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.TopSimilarObjectsFilterPopover);
// FACE ATTRIBUTES
const GenderFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.GenderFilterPopover);
const AgeFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.AgeFilterPopover);
const EmotionFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.EmotionsFilterPopover);
const MasksFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.MasksFilterPopover);
const LivenessFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.LivenessFilterPopover);
const DeepfakeFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.DeepfakeFilterPopover);
const FaceIdsFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.FaceIdsFilterPopover);
// BODY ATTRIBUTES
const ApparentGenderFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.ApparentGenderFilterPopover);
const ApparentAgeFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.ApparentAgeFilterPopover);
const UpperAttributesFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.UpperAttributesFilterPopover);
const LowerAttributesFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.LowerAttributesFilterPopover);
const ShoesFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.ShoesFilterPopover);
const HeadWearFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.HeadWearFilterPopover);
const BackpackFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.BackpackFilterPopover);
// LOCATION
const LocationFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.LocationFilterPopover);

export const EventFiltersWithLeftPopover = {
  General: {
    DateFilter: DateFilterWithLeftPopover,
    VideoSourceFilter: VideoSourceFilterWithLeftPopover,
    HandlersFilter: HandlersFilterWithLeftPopover,
    SimilarityFilter: SimilarityFilterWithLeftPopover,
  },
  Comparing: {
    ComparingAttributeFilter: ComparingAttributeFilterWithLeftPopover,
    TopSimilarObjectsFilter: TopSimilarObjectsFilterWithLeftPopover,
  },
  Face: {
    GenderFilter: GenderFilterWithLeftPopover,
    AgeFilter: AgeFilterWithLeftPopover,
    EmotionFilter: EmotionFilterWithLeftPopover,
    MasksFilter: MasksFilterWithLeftPopover,
    LivenessFilter: LivenessFilterWithLeftPopover,
    DeepfakeFilter: DeepfakeFilterWithLeftPopover,
    FaceIdsFilter: FaceIdsFilterWithLeftPopover,
  },
  Body: {
    ApparentGenderFilter: ApparentGenderFilterWithLeftPopover,
    ApparentAgeFilter: ApparentAgeFilterWithLeftPopover,
    UpperAttributesFilter: UpperAttributesFilterWithLeftPopover,
    LowerAttributesFilter: LowerAttributesFilterWithLeftPopover,
    ShoesFilter: ShoesFilterWithLeftPopover,
    HeadWearFilter: HeadWearFilterWithLeftPopover,
    BackpackFilter: BackpackFilterWithLeftPopover,
  },
  Location: {
    LocationFilter: LocationFilterWithLeftPopover,
  },
};

// FACE FILTERS WITH RIGHT POPOVER
const ExternalIdFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.ExternalIdFilterPopover);
const ListsFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.ListsFilterPopover);
const UserDataFilterWithRightPopover = withSideMenuItemRightPopover(Popovers.UserDataFilterPopover);

export const FaceFiltersWithRightPopover = {
  DateFilter: DateFilterWithRightPopover,
  ExternalIdFilter: ExternalIdFilterWithRightPopover,
  SimilarityFilter: SimilarityFilterWithRightPopover,
  ListsFilter: ListsFilterWithRightPopover,
  UserDataFilter: UserDataFilterWithRightPopover,
};

// FACE FILTERS WITH LEFT POPOVER
const ExternalIdFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.ExternalIdFilterPopover);
const ListsFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.ListsFilterPopover);
const UserDataFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.UserDataFilterPopover);

export const FaceFiltersWithLeftPopover = {
  DateFilter: DateFilterWithLeftPopover,
  ExternalIdFilter: ExternalIdFilterWithLeftPopover,
  SimilarityFilter: SimilarityFilterWithLeftPopover,
  ListsFilter: ListsFilterWithLeftPopover,
  UserDataFilter: UserDataFilterWithLeftPopover,
};
